import { createSession } from '../../actions/sessionActions';
import {
  httpGet, httpPost, httpPut, httpDelete,
} from '../httpCalls';
import { mapPagination } from './maps';

/* eslint-disable import/prefer-default-export */

export const getItems = (url) => httpGet(url).then((valuesRequest) => {
  const values = mapPagination(valuesRequest);
  return values;
});

export const getItemsPost = (url,item) => httpPost(url,item).then((valuesRequest) => {
  const values = mapPagination(valuesRequest);
  return values;
});

export const createItem = (url, item) => httpPost(url, item).then((newItem) => {
}, (error) => Promise.reject(error));
export const updateItems = (url, items) => httpPut(url, items).then(() => {

}, (error) => Promise.reject(error));
export const removeItem = (url, item) => httpDelete(`${url}/${item.id}`).then(() => {
}, (error) => Promise.reject(error));
export const tableEdited = (dispatch, value = true) => {
  return dispatch(createSession({ isBlocking: value }));
};
// tableEdited: (value = true) => dispatch(createSession({ isBlocking: value })),

export const getCatalog = (api) => httpGet(`${api}`).then((valuesRequest) => mapPagination(valuesRequest));
export const getSortedItems = (url, dispatch) =>
  httpGet(url).then((valuesRequest) => {
    const values = mapPagination(valuesRequest);
    return values;
  });